/**
 * Check if an error response contains a specific field in its errors object.
 *
 * @param errors The errors object from an API error response (e.g. error.data.errors).
 * @param field The field name to check for.
 */
export const hasErrorField = (
  errors: unknown,
  field: string,
): errors is Record<string, any> =>
  errors != null && typeof errors === 'object' && field in errors;
